$(document).ready(function(){
  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function () {
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  var selcted_val = $('#tabs-nav li:first-child a').text();
  $('.mob_select').text(selcted_val);
  
  if(window.outerWidth < 991){
    $(document).on('click', '.mob_select', function(){
      $('#tabs-nav').slideToggle();
      $(this).toggleClass('arrow_rotate');
    });
    $('#tabs-nav li').click(function () {
      $(this).parents('#tabs-nav').slideUp();
      var selted_option = $(this).text();
      $('.mob_select').text(selted_option);
      
    });
  }


//   jQuery.getJSON('/products/uriage-bundle-ds-hair-shampoo-equilibrant-antipelliculaire.json', function(product) {
//     console.log(product);
//   alert('The title of this product is ' + product.title);
// });

  // Reorder Functionality
  $(document).on('click', '.view_order .reorder', function(){
    $(this).find('span.cstm_loader').removeClass('hide');
    var selected_products = [];
    $(this).parents('.order_details').find('.order_products .order_product').each(function(){
      var variant_id = $(this).attr('data-variant-id');
      var product_id = $(this).attr('data-product-id');
      
      selected_products.push(variant_id);
      for( var i=0; i < selected_products.length; i++){
        (function(i){
          setTimeout(function(){
            var single_product_data = selected_products[i];
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data:{
                id: single_product_data,
                quantity: 1
              },
              dataType: 'json',
              success: function(){ 
                var iteration_length = i + 1;
                if (iteration_length == selected_products.length) {
                  $('.order_product[data-product-id="'+ product_id +'"]').closest('.order_details').find('span.cstm_loader').addClass('hide');
                   window.location.href ='/cart';
                }
              },
              error: function() { 
                $('.order_product[data-product-id="'+ product_id +'"]').closest('.order_details').find('.error_msg').addClass('show_error');
                $('.order_product[data-product-id="'+ product_id +'"]').closest('.order_details').find('span.cstm_loader').addClass('hide');
                return;
              }
            });
          }, 1500 * i);
        }(i));
      }
   });
  });
});








